import React, { useCallback } from 'react';
import { ACTIONTYPE } from '../../../AppStateProvider/AppStateProvider';
import { axiosApiInstance } from '../../../AppStateProvider/authentification/axiosApiInstanse';

export default function useGetHistoryResults(dispatch: React.Dispatch<ACTIONTYPE>) {
  const fetchHistoryResults = useCallback(() => {
    return axiosApiInstance
      .get(process.env.REACT_APP_API! + '/getResults')
      .then((response) => {
        dispatch({ type: 'history-results', result: response.data.Items });
      })

      .catch((error) => {
        dispatch({ type: 'history-results', result: [] });
      });
  }, [dispatch]);

  return { fetchHistoryResults } as const;
}
